import { backendPy } from "System/system";
import store from "System/reduxStore";

const getMode = () => store.getState().data.useNumba ? "numba" : "pandas";

// -------------------------------------------------------
// -------------------------------------------------------
export const calculatePerformanceData = cb => async (dispatch) => {
  const { id, datapath, calcParams, parameters, normMap } = store.getState().project;
  // Flatten normMap to the prefix-based format the backend expects
  const norm = {};
  if (normMap) {
    Object.entries(normMap).forEach(([docType, mapping]) => {
      if (mapping.positive) norm["p" + docType] = mapping.positive;
      if (mapping.negative) norm["n" + docType] = mapping.negative;
    });
  }
  const perfParams = calcParams?.performanceRatios || {};
  await backendPy("performance", "calculate", {
    projectid: id,
    datapath,
    reference_date: parameters?.referenceDate || "",
    calcParamsString: JSON.stringify(perfParams),
    normString: JSON.stringify(norm),
    mode: getMode(),
  });
  dispatch({type: "SET_PERFORMANCE_CALCULATED"});
  await dispatch(getPerformanceData( () => {}));
  cb();
};

// -------------------------------------------------------
// -------------------------------------------------------
export const getPerformanceData = (cb) => async (dispatch) => {
  const { id, datapath } = store.getState().project;
  const result = await backendPy("performance", "read", {
    projectid: id, datapath,
  });
  if(result.data) {
    dispatch({type: "SET_PERFORMANCE_DATA", performance: result.data});
  }
  cb();
};